import { emitter } from 'shared/helpers/mitt';

/**
 * Emits a toast message event using a global emitter for alerts.
 * @param {string} message - The message to be displayed in the alert toast.
 * @param {string} type - The type of alert (success, error, warning, info). Defaults to 'success'.
 */
export const useAlert = (message, type = 'success') => {
  emitter.emit('newToastMessage', { message, action: { type } });
};